import { communityService } from "@/api/services/community.service";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { authMiddlewareServer } from "../middleware/auth";

const resourceSchema = z.object({
  resourceType: z.enum(["forum_question", "library_path"]),
  resourceId: z.string().min(1),
});

export const getFollowStatusFn = createServerFn({ method: "GET" })
  .middleware([authMiddlewareServer])
  .inputValidator(resourceSchema)
  .handler(async ({ context, data }) => ({
    following: await communityService.isFollowing(
      context.auth.userId,
      data.resourceType,
      data.resourceId,
    ),
  }));

export const setFollowStatusFn = createServerFn({ method: "POST" })
  .middleware([authMiddlewareServer])
  .inputValidator(resourceSchema.extend({ following: z.boolean() }))
  .handler(async ({ context, data }) => ({
    following: await communityService.setFollowing(
      context.auth.userId,
      data.resourceType,
      data.resourceId,
      data.following,
    ),
  }));

export const listNotificationsFn = createServerFn({ method: "GET" })
  .middleware([authMiddlewareServer])
  .handler(async ({ context }) => ({
    notifications: await communityService.listNotifications(
      context.auth.userId,
    ),
  }));

export const markNotificationReadFn = createServerFn({ method: "POST" })
  .middleware([authMiddlewareServer])
  .inputValidator(z.object({ notificationId: z.string().optional() }))
  .handler(async ({ context, data }) => {
    await communityService.markNotificationRead(
      context.auth.userId,
      data.notificationId,
    );
    return { success: true };
  });

export const getLibraryProgressFn = createServerFn({ method: "GET" })
  .middleware([authMiddlewareServer])
  .handler(async ({ context }) => ({
    completedEntryIds: await communityService.getCompletedEntryIds(
      context.auth.userId,
    ),
  }));

export const setLibraryProgressFn = createServerFn({ method: "POST" })
  .middleware([authMiddlewareServer])
  .inputValidator(
    z.object({ entryId: z.string().min(1), completed: z.boolean() }),
  )
  .handler(async ({ context, data }) => ({
    completed: await communityService.setEntryCompleted(
      context.auth.userId,
      data.entryId,
      data.completed,
    ),
  }));

export const recordContentViewFn = createServerFn({ method: "POST" })
  .inputValidator(
    z.object({
      resourceType: z.enum(["forum_question", "library_entry"]),
      resourceId: z.string().min(1),
      visitorKey: z.string().min(16).max(128),
    }),
  )
  .handler(async ({ data }) => ({
    counted: await communityService.recordView(
      data.resourceType,
      data.resourceId,
      data.visitorKey,
    ),
  }));
